import { ConnectionFollowerPoint } from '../../../redux/api/fymAPI.types';

/**
 * The values the card sparkline draws for a follower series.
 *
 * Two things happen here. Days nothing was read drop out, because a gap is not
 * a fall to zero. What is left is shifted down by the smallest count in the
 * window: a follower count is a big number with a small movement on top of it,
 * and the shared sparkline draws from zero, so the raw series would be a
 * straight line. The chart carries shape and no axis, so the shift costs
 * nothing and the movement becomes visible.
 */
export function followerSparklineValues(series: ConnectionFollowerPoint[]): number[] {
  const counts = series.map((point) => point.followers).filter((followers): followers is number => followers !== null);

  if (counts.length === 0) {
    return [];
  }

  const lowest = Math.min(...counts);
  return counts.map((followers) => followers - lowest);
}
